export const ErrorMsg = {
    LoadExtensionFail: 'Load Extension failed',
    NotFoundActivateMethod: 'Not found activate function, the extension must export an activate function as entry.',
};
